import i18next from 'i18next';
import { AboutUs } from '../components/aboutUs/aboutUs';
import { Account } from '../components/account/account';
import { Achievements } from '../components/achievement/achievements';
import { AddressBook } from '../components/addressBook/addressBook';
import { AllServices } from '../components/allServices/allServices';
import { AccountSettings } from '../components/auth/accountSettings/accountSettings';
import { Register } from '../components/auth/register/register';
import { SelectedCategory } from '../components/categories/selectedCategory';
import { Credits } from '../components/credits/credits';
import { WebsiteHomePage } from '../components/homePage/websiteHomePage';
import { Info } from '../components/info/info';
import { NewsItem } from '../components/news/newsItem';
import { NewsList } from '../components/news/newsList';
import { OrderDetails } from '../components/orderHistory/orderDetails';
import { OrderHistory } from '../components/orderHistory/orderHistory';
import { Partners } from '../components/partners/partners';
import { CreditsPayments } from '../components/payment/creditsPayments';
import { PointSelection } from '../components/pointSelection/pointSelection';
import { SelectedPoint } from '../components/pointSelection/selectedPoint';
import { PrivacyPolicy } from '../components/policy/privacyPolicy';
import { TermsAndConditions } from '../components/policy/termsAndConditions';
import { ShoppingCart } from '../components/shoppingCart/shoppingCart';
import { Support } from '../components/support/support';
import { WhereTo } from '../components/whereTo/whereTo';
import { RouteConfig, PrivateRouteConfig } from './routeConfig';
import { GoodsList } from '../components/goods/goodsList';
import { GoodsItem } from '../components/goods/goodsItem';
import { FaqList } from '../components/faq/faqList';
import { MobileHomePage } from '../components/homePage/mobileHomePage';
import { SelectedGroupServices } from '../components/selectedService/selectedService';
import { LoginPage } from '../components/auth/login/loginPage';
import { CompanyTitle } from '../helpers/clientConfigs';
import { Checkout } from '../components/checkout/checkout';
import { CreditsItem } from '@/components/credits/creditsItem';

export const HomeRoute = new RouteConfig(
  {
    lt: '/',
    en: '/',
  },
  CompanyTitle,
  <WebsiteHomePage />
);
export const MobileHomeRoute = new RouteConfig(
  {
    lt: '/pradzia',
    en: '/home',
  },
  CompanyTitle,
  <MobileHomePage />
);
export const CartRoute = new RouteConfig(
  {
    lt: '/krepselis',
    en: '/cart',
  },
  i18next.t('payment:cart'),
  <ShoppingCart />,
  'guest',
  true
);
export const RegistrationRoute = new RouteConfig(
  {
    lt: '/registracija',
    en: '/register',
  },
  i18next.t('account:registration'),
  <Register />,
  'onlyNotAuthenticated'
);
export const AchievementsRoute = new RouteConfig(
  {
    lt: '/pasiekimai',
    en: '/achievements',
  },
  i18next.t('achievement:achievements'),
  <Achievements />
);
export const SearchRoute = new RouteConfig(
  {
    lt: '/paieska',
    en: '/search',
  },
  i18next.t('services:allServices'),
  <AllServices />
);
export const AccountRoute = new RouteConfig(
  {
    lt: '/vartotojas',
    en: '/account',
  },
  i18next.t('account:account'),
  <Account />
);
export const RulesRoute = new RouteConfig(
  {
    lt: '/taisykles',
    en: '/terms-and-conditions',
  },
  i18next.t('info:rules'),
  <TermsAndConditions />
);
export const PrivacyPolicyRoute = new RouteConfig(
  {
    lt: '/privatumo-politika',
    en: '/privacy-policy',
  },
  i18next.t('info:privacyPolicy'),
  <PrivacyPolicy />
);
export const SalesPointsRoute = new RouteConfig(
  {
    lt: '/priemimo-skyriai',
    en: '/unit-locations',
  },
  i18next.t('salesPoint:salesPoints'),
  <PointSelection />
);

export const SalesPointRoute = new RouteConfig(
  {
    lt: '/priemimo-skyrius',
    en: '/sales-point',
  },
  i18next.t('salesPoint:salesPoints'),
  <SelectedPoint />
);
export const PartnersRoute = new RouteConfig(
  {
    lt: '/partneriai',
    en: '/partners',
  },
  i18next.t('info:partners'),
  <Partners />
);
export const NewsItemRoute = new RouteConfig(
  {
    lt: '/akcijos-ir-naujienos/:title',
    en: '/offers-and-news/:title',
  },
  i18next.t('news:menuTitle'),
  <NewsItem />
);
export const NewsRoute = new RouteConfig(
  {
    lt: '/akcijos-ir-naujienos',
    en: '/offers-and-news',
  },
  i18next.t('news:menuTitle'),
  <NewsList />
);
export const AboutUsRoute = new RouteConfig(
  {
    lt: '/apie-mus',
    en: '/about-us',
  },
  i18next.t('info:aboutUs'),
  <AboutUs />
);
export const WhereToRoute = new RouteConfig(
  {
    lt: '/kur-priduosite',
    en: '/where-to',
  },
  i18next.t('payment:whereToDeliver'),
  <WhereTo />
);
export const AddressBookRoute = new PrivateRouteConfig(
  {
    lt: '/adresu-knyga',
    en: '/address-book',
  },
  i18next.t('address:addressBook'),
  <AddressBook />
);
export const AccountSettingsRoute = new PrivateRouteConfig(
  {
    lt: '/paskyros-nustatymai',
    en: '/account-settings',
  },
  i18next.t('account:settings'),
  <AccountSettings />
);
export const CreditsRoute = new RouteConfig(
  {
    lt: '/kreditai-ir-kuponai',
    en: '/credits-and-coupons',
  },
  i18next.t('account:creditsAndCoupons'),
  <Credits />
);
export const CreditsPaymentsRoute = new PrivateRouteConfig(
  {
    lt: '/kreditu-pirkimas',
    en: '/buy-credits',
  },
  i18next.t('payment:paymentMethods'),
  <CreditsPayments />,
  true
);
export const OrderCheckoutRoute = new RouteConfig(
  {
    lt: '/uzsakymo-apmokejimas',
    en: '/order-checkout',
  },
  i18next.t('payment:orderCheckout'),
  <Checkout />
);
export const OrderHistoryRoute = new PrivateRouteConfig(
  {
    lt: '/uzsakymu-istorija',
    en: '/order-history',
  },
  i18next.t('order:history'),
  <OrderHistory />,
  true
);
export const OrderDetailRoute = new PrivateRouteConfig(
  {
    lt: '/uzsakymas',
    en: '/order-detail',
  },
  i18next.t('order:history'),
  <OrderDetails />,
  true
);
export const LoginRoute = new RouteConfig(
  {
    lt: '/prisijungimas',
    en: '/login',
  },
  i18next.t('account:login'),
  <LoginPage />,
  'onlyNotAuthenticated',
  undefined,
  true
);
export const SupportRoute = new RouteConfig(
  {
    lt: '/pagalba',
    en: '/support',
  },
  i18next.t('info:contactUs'),
  <Support />
);
export const CategoryRoute = new RouteConfig(
  {
    lt: '/paslaugos/:category/:categoryId',
    en: '/services/:category/:categoryId',
  },
  i18next.t('services:services'),
  <SelectedCategory />
);

export const CategoryGroupRoute = new RouteConfig(
  {
    lt: '/paslaugos/:category/:group/:categoryId',
    en: '/services/:category/:group/:categoryId',
  },
  i18next.t('services:services'),
  <SelectedCategory />
);

export const ServicesRoute = new RouteConfig(
  {
    lt: '/paslaugos',
    en: '/services',
  },
  i18next.t('services:services'),
  <SelectedGroupServices />
);

export const InfoRoute = new RouteConfig(
  {
    lt: '/informacija',
    en: '/info',
  },
  i18next.t('info:information'),
  <Info />
);

export const GoodsRoute = new RouteConfig(
  {
    lt: '/prekes',
    en: '/goods',
  },
  i18next.t('services:products'),
  <GoodsList />
);

export const GoodsItemRoute = new RouteConfig(
  {
    lt: '/prekes/:name',
    en: '/goods/:name',
  },
  i18next.t('services:products'),
  <GoodsItem />
);

export const FaqRoute = new RouteConfig(
  {
    lt: '/duk',
    en: '/faq',
  },
  i18next.t('faq:menuTitle'),
  <FaqList />
);

export const CreditsItemRoute = new RouteConfig(
  {
    lt: '/kreditai/:name',
    en: '/credits/:name',
  },
  i18next.t('services:credits'),
  <CreditsItem />
);

export const DefaultWebsiteRoutes: RouteConfig[] = [
  HomeRoute,
  CartRoute,
  SearchRoute,
  RegistrationRoute,
  AchievementsRoute,
  RulesRoute,
  PrivacyPolicyRoute,
  SalesPointRoute,
  SalesPointsRoute,
  PartnersRoute,
  NewsItemRoute,
  NewsRoute,
  AboutUsRoute,
  WhereToRoute,
  AddressBookRoute,
  AccountSettingsRoute,
  CreditsRoute,
  CreditsItemRoute,
  CreditsPaymentsRoute,
  OrderCheckoutRoute,
  OrderHistoryRoute,
  OrderDetailRoute,
  LoginRoute,
  SupportRoute,
  CategoryRoute,
  CategoryGroupRoute,
  GoodsRoute,
  GoodsItemRoute,
  FaqRoute,
];

export const AppRoutes: RouteConfig[] = [
  MobileHomeRoute,
  ServicesRoute,
  AccountRoute,
  CartRoute,
  SearchRoute,
  RegistrationRoute,
  AchievementsRoute,
  SalesPointRoute,
  SalesPointsRoute,
  PartnersRoute,
  InfoRoute,
  WhereToRoute,
  AddressBookRoute,
  AccountSettingsRoute,
  CreditsRoute,
  CreditsItemRoute,
  CreditsPaymentsRoute,
  OrderCheckoutRoute,
  OrderHistoryRoute,
  OrderDetailRoute,
  SupportRoute,
  GoodsItemRoute,
  FaqRoute,
  RulesRoute,
  PrivacyPolicyRoute,
];

export const FormadaRoutes: RouteConfig[] = [
  HomeRoute,
  CartRoute,
  SearchRoute,
  RegistrationRoute,
  RulesRoute,
  PrivacyPolicyRoute,
  SalesPointRoute,
  SalesPointsRoute,
  NewsItemRoute,
  NewsRoute,
  AboutUsRoute,
  WhereToRoute,
  AddressBookRoute,
  AccountSettingsRoute,
  CreditsRoute,
  CreditsItemRoute,
  CreditsPaymentsRoute,
  OrderCheckoutRoute,
  OrderHistoryRoute,
  OrderDetailRoute,
  LoginRoute,
  SupportRoute,
  CategoryRoute,
  CategoryGroupRoute,
  GoodsRoute,
  GoodsItemRoute,
  FaqRoute,
];
